import type { JSX } from 'preact';
import { LocationProvider, Route, Router } from 'preact-iso';
import { LegalFooter } from './components/LegalFooter';
import { AlertsRoute } from './routes/AlertsRoute';
import { ConfigRoute } from './routes/ConfigRoute';
import { DashboardRoute } from './routes/DashboardRoute';
import { DeviceRoute } from './routes/DeviceRoute';
import { Guard } from './routes/Guard';
import { LandingRoute } from './routes/LandingRoute';
import { LoginRoute } from './routes/LoginRoute';
import { MnemonicShowRoute } from './routes/MnemonicShowRoute';
import { CheckoutCancelRoute } from './routes/CheckoutCancelRoute';
import { CheckoutRedirectRoute } from './routes/CheckoutRedirectRoute';
import { CheckoutSuccessRoute } from './routes/CheckoutSuccessRoute';
import { ResetRequestRoute } from './routes/ResetRequestRoute';
import { RestoreMnemonicRoute } from './routes/RestoreMnemonicRoute';
import { SettingsRoute } from './routes/SettingsRoute';
import { SignupRoute } from './routes/SignupRoute';

function Protected({ Component }: { Component: () => JSX.Element }) {
  return (
    <Guard>
      <Component />
    </Guard>
  );
}

export function App() {
  return (
    <LocationProvider>
      <Router>
        <Route path="/" component={LandingRoute} />
        <Route path="/signup" component={SignupRoute} />
        <Route path="/login" component={LoginRoute} />
        <Route path="/reset-request" component={ResetRequestRoute} />
        <Route path="/onboarding/mnemonic" component={MnemonicShowRoute} />
        <Route
          path="/login/restore-mnemonic"
          component={RestoreMnemonicRoute}
        />
        <Route path="/checkout/redirect" component={CheckoutRedirectRoute} />
        <Route path="/checkout/success" component={CheckoutSuccessRoute} />
        <Route path="/checkout/cancel" component={CheckoutCancelRoute} />
        <Route
          path="/dashboard"
          component={() => <Protected Component={DashboardRoute} />}
        />
        <Route
          path="/alerts"
          component={() => <Protected Component={AlertsRoute} />}
        />
        <Route
          path="/config"
          component={() => <Protected Component={ConfigRoute} />}
        />
        <Route
          path="/devices/:id"
          component={() => <Protected Component={DeviceRoute} />}
        />
        <Route
          path="/settings"
          component={() => <Protected Component={SettingsRoute} />}
        />
        <Route default component={LandingRoute} />
      </Router>
      <LegalFooter />
    </LocationProvider>
  );
}
